import {
    HAS_DRAFTSINDIVIDUAL_BEGIN,
    HAS_DRAFTSINDIVIDUAL_SUCCESS,
    HAS_DRAFTSINDIVIDUAL_FAILURE
} from '../../../Actions/FormServiceActions/GenericFormServiceActions/HasDraftsIndividualAction';

const initialState = {
    items: [],
    hasDraftsIndividualBegin: false,
    hasDraftsIndividualSucceeded: false,
    hasDraftsIndividualError: null,
};

export default function formReducer(state = initialState, action) {
    switch (action.type) {
        case HAS_DRAFTSINDIVIDUAL_BEGIN:
            return {
                ...state,
                hasDraftsIndividualBegin: true
            };

        case HAS_DRAFTSINDIVIDUAL_SUCCESS:
            return {
                ...state,
                items: action.payload,
                hasDraftsIndividualBegin: false,
                hasDraftsIndividualSucceeded: true,
                hasDraftsIndividualError: null
            }

        case HAS_DRAFTSINDIVIDUAL_FAILURE:
            return {
                ...state,
                hasDraftsIndividualBegin: false,
                hasDraftsIndividualSucceeded: true,
                hasDraftsIndividualError: action.payload
            };

        default:
            return state;
    }
}